// Chemin: C:\gestion-copro\src\services\user.service.ts
// Service de gestion des utilisateurs
// Session 57 : Création pour fonctionnalité "Lier un compte"
// Session 79 : Ajout emailSent et emailError dans le type de retour
// Session 82 : Ajout updateUserEmail pour synchronisation Auth/Firestore

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

// ============================================
// TYPES
// ============================================

export interface CreateUserAccountParams {
  email: string;
  password: string;
  nom: string;
  prenom: string;
  role: 'cs' | 'coproprietaire';
  coproprieteId: string;
  membreId: string;
  membreCollection: 'membresCS' | 'coproprietaires';
}

// Session 79 : Ajout emailSent et emailError pour feedback utilisateur
export interface CreateUserAccountResult {
  success: boolean;
  uid: string;
  email: string;
  message: string;
  emailSent: boolean;
  emailError?: string;
}

// Session 82 : Types pour mise à jour email
export interface UpdateUserEmailParams {
  userId: string;
  newEmail: string;
}

export interface UpdateUserEmailResult {
  success: boolean;
  message: string;
  oldEmail: string;
  newEmail: string;
}

// ============================================
// FONCTIONS
// ============================================

/**
 * Créer un compte utilisateur lié à un membre CS ou copropriétaire
 * Appelle la Cloud Function createUserAccount
 */
export const createLinkedUserAccount = async (
  params: CreateUserAccountParams
): Promise<CreateUserAccountResult> => {
  const createUserAccountFn = httpsCallable<CreateUserAccountParams, CreateUserAccountResult>(
    functions,
    'createUserAccount'
  );

  const result = await createUserAccountFn(params);
  return result.data;
};

/**
 * Session 82 : Mettre à jour l'email d'un utilisateur
 * Synchronise Firebase Auth ET Firestore (users + membre lié)
 * Appelle la Cloud Function updateUserEmail
 */
export const updateUserEmail = async (
  params: UpdateUserEmailParams
): Promise<UpdateUserEmailResult> => {
  const updateUserEmailFn = httpsCallable<UpdateUserEmailParams, UpdateUserEmailResult>(
    functions,
    'updateUserEmail'
  );

  const result = await updateUserEmailFn(params);
  return result.data;
};

/**
 * Générer un mot de passe temporaire sécurisé
 * Format: Copro + Année + ! + 4 caractères aléatoires
 * Exemple: Copro2026!Abc3
 */
export const generateTemporaryPassword = (): string => {
  const year = new Date().getFullYear();
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  let randomPart = '';
  
  for (let i = 0; i < 4; i++) {
    randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return `Copro${year}!${randomPart}`;
};

/**
 * Valider un email
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
